import { useEffect } from "react";
import useDrivePicker from "react-google-drive-picker";

const DrivePicker = ({ onGoogleDriveSuccess, DriveRef, driveAccessToken }) => {
  const [openPicker] = useDrivePicker();

  useEffect(() => {
    if (driveAccessToken && DriveRef.current) {
      setTimeout(() => {
        DriveRef.current.click();
      }, 1000);
    }
  }, [driveAccessToken]);

  const handleOpenPicker = () => {
    openPicker({
      clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      developerKey: process.env.REACT_APP_GOOGLE_DEVELOPER_KEY,
      token: driveAccessToken,
      viewId: "DOCS_VIDEOS",
      showUploadView: true,
      showUploadFolders: true,
      supportDrives: true,
      multiselect: false,
      callbackFunction: (data) => {
        $(".picker-dialog").css("z-index", 5000);
        if (data.action === "picked") {
          onGoogleDriveSuccess(data.docs[0]);
        }
      },
    });
  };

  return (
    <div
      ref={DriveRef}
      id="GoogleDrivepickerdiv"
      onClick={handleOpenPicker}
    ></div>
  );
};

export default DrivePicker;
